// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.css-1iyq7zh-MuiDataGrid-columnHeaders{
    /* background-color: #E2E3E5; */
    background-color: #3C48AD !important;
}

.seacrh-filter>div:first-child{
    margin-right: 40px;
    border:1px solid lightgrey;
    background-color:#F1F3F5;
    border-radius: 25px;
    padding-left: 5px;
}

.seacrh-filter>div:first-child:hover{
    width:350px
}

.seacrh-filter>div:first-child:after{
    display: none;
}
.seacrh-filter>div:first-child:before{
    border-bottom: none !important;
}

/* .readmoreIcon{
    display: none !important;
} */

.firstreadmoreIcon{
    display: none !important;
}

.MuiDataGrid-row:hover .firstreadmoreIcon{
    display: block !important;
}

.MuiDataGrid-row:hover .readmoreIcon{
    display: none !important;
}

.pop-btn-rad{
    margin-top: 30px;
}

.pop-btn-rad>button{
   background-color: #1976d2;
   border: none;
   border-radius: 30px;
   color: white;
   cursor: pointer;
}

.pop-btn-rad-download{
    background-color: darkgray;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    padding:20px;
}

.pop-btn-rad>button:hover{
    background-color: powderblue;
    color: white;
   
 }

 .pop-btn-rad-download:hover{
   background-color: powderblue;
   color: white
}

/* .rad-invoice-table */
.table-container::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .table-container::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }

.rad-invoice-table-head{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    background-color: #1976d2;
    padding: 10px;
    position: sticky;
    top: 0;
    color: white;
    z-index: 1;
    text-align: center;
    /* width: 100%; */
}


.rad-invoice-table-body{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    padding: 10px;
    margin: 10px 0px;
    text-align: center;
    border-radius: 10px;
    border: 0.5px solid grey;
    color: gray;
    /* width: 100%; */
}

.card-inside{
    display: flex;
    justify-content: space-between;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Radiologists/Radiologistics.css"],"names":[],"mappings":";;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;AACjB;AACA;IACI,8BAA8B;AAClC;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,mBAAmB;GACnB,YAAY;GACZ,eAAe;AAClB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;;CAEf;;CAEA;GACE,4BAA4B;GAC5B;AACH;;AAEA,uBAAuB;AACvB;IACI,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;AAEF;IACI,aAAa;IACb,gDAAgD;IAChD,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,gDAAgD;IAChD,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":["\n\n.css-1iyq7zh-MuiDataGrid-columnHeaders{\n    /* background-color: #E2E3E5; */\n    background-color: #3C48AD !important;\n}\n\n.seacrh-filter>div:first-child{\n    margin-right: 40px;\n    border:1px solid lightgrey;\n    background-color:#F1F3F5;\n    border-radius: 25px;\n    padding-left: 5px;\n}\n\n.seacrh-filter>div:first-child:hover{\n    width:350px\n}\n\n.seacrh-filter>div:first-child:after{\n    display: none;\n}\n.seacrh-filter>div:first-child:before{\n    border-bottom: none !important;\n}\n\n/* .readmoreIcon{\n    display: none !important;\n} */\n\n.firstreadmoreIcon{\n    display: none !important;\n}\n\n.MuiDataGrid-row:hover .firstreadmoreIcon{\n    display: block !important;\n}\n\n.MuiDataGrid-row:hover .readmoreIcon{\n    display: none !important;\n}\n\n.pop-btn-rad{\n    margin-top: 30px;\n}\n\n.pop-btn-rad>button{\n   background-color: #1976d2;\n   border: none;\n   border-radius: 30px;\n   color: white;\n   cursor: pointer;\n}\n\n.pop-btn-rad-download{\n    background-color: darkgray;\n    border: none;\n    border-radius: 30px;\n    cursor: pointer;\n    padding:20px;\n}\n\n.pop-btn-rad>button:hover{\n    background-color: powderblue;\n    color: white;\n   \n }\n\n .pop-btn-rad-download:hover{\n   background-color: powderblue;\n   color: white\n}\n\n/* .rad-invoice-table */\n.table-container::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .table-container::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n.rad-invoice-table-head{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    background-color: #1976d2;\n    padding: 10px;\n    position: sticky;\n    top: 0;\n    color: white;\n    z-index: 1;\n    text-align: center;\n    /* width: 100%; */\n}\n\n\n.rad-invoice-table-body{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    padding: 10px;\n    margin: 10px 0px;\n    text-align: center;\n    border-radius: 10px;\n    border: 0.5px solid grey;\n    color: gray;\n    /* width: 100%; */\n}\n\n.card-inside{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
